module.exports = __webpack_public_path__ + "static/img/icon5-9.55cbaa27.png";